import { observer } from "mobx-react-lite";
import { useAppStore } from "../../../hooks/useStores.tsx";
import ImageUploadPopup from "../ImageUploadPopup/ImageUploadPopup.tsx";

interface IProps {
	maxWidth?: string;
	// Ads (DesignEditor) uploads register the image via the engine so it keeps
	// a real vhash; every other upload only needs a stable S3 URL.
	isAdsUpload?: boolean;
}

const BriaUploadPopup = ({ maxWidth, isAdsUpload }: IProps) => {
	const { imagesStore } = useAppStore();
	const handleCloseClick = () => {
		imagesStore.openUploadPopup = false;
	};

	return (
		<ImageUploadPopup
			open={imagesStore.openUploadPopup}
			onUpload={async (e) => {
				if (!imagesStore.isLogoUploading) {
					const res = isAdsUpload
						? await imagesStore.uploadImageViaAPI(
								e?.target?.files?.[0],
								imagesStore.uploadToUserGallery.toString(),
							)
						: await imagesStore.uploadImageToS3(
								e?.target?.files?.[0],
								imagesStore.uploadToUserGallery.toString(),
							);
					if (res?.visualId || res?.imageUrl) {
						imagesStore.uploadProcessDone = true;
					}
				} else {
					await imagesStore.uploadLogo(e?.target?.files?.[0]);
					imagesStore.uploadProcessDone = true;
				}
				handleCloseClick();
			}}
			handleCloseClick={handleCloseClick}
			maxWidth={maxWidth}
			loading={imagesStore.isImageUploading}
		/>
	);
};

const ObservedComponent = observer(BriaUploadPopup);
export default ObservedComponent;
